import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

export interface PrivatePensionNewApplicationHeaderProps {
  onClose: () => void;
}

export const PrivatePensionNewApplicationHeader: React.FC<
  PrivatePensionNewApplicationHeaderProps
> = ({ onClose }) => {
  return (
    <HStack justifyContent="space-between">
      <HStack space={Spacing['inline.nano']} alignItems="center">
        <UI.IconButton
          onPress={onClose}
          icon="ArrowLeft"
          iconSize="xs"
          testId="back"
          iconColor={Color['neutral.black']}
          p={0}
        />
        <UI.Text variant="semibold" color="neutral.black">
          Aplicar
        </UI.Text>
      </HStack>

      <UI.IconButton
        testId="icon"
        icon="CloseModal"
        iconSize="xs"
        p={0}
        variant="rounded"
        borderWidth={0.05}
        backgroundColor="transparent"
        iconColor={Color['brand.primary.principal']}
        borderColor={Color['brand.primary.principal']}
        onPress={onClose}
      />
    </HStack>
  );
};
